export const styledObject = props => {
  return {
    height: props.$height,
    minWidth: props.$width,
    backgroundColor: props.theme[props.$backgroundColor],
    borderColor: props.theme[props.$borderColor],
    color: props.theme[props.$color],
    // "&:hover": {
    //   backgroundColor: `${props.theme[props.$hoverBackground]}!important`,
    //   borderColor: `${props.theme[props.$hoverBorderColor]}!important`,
    //   color: `${props.theme[props.$hoverColor]}!important`,
    // },
    "&:hover": {
      backgroundColor: `${props.theme[props.$hoverBackground]}!important`,
      borderColor: `${props.theme[props.$hoverBorderColor]}!important`,
      color: `${props.theme[props.$hoverColor]}!important`,
    },
    "&:focus": {
      backgroundColor: props.theme[props.$hoverBackground],
      borderColor: props.theme[props.$borderColor],
      color: `${props.theme[props.$hoverColor]}!important`,
    },
    "&[disabled]": {
      borderColor: `${props.theme["neu300"]}!important`,
      backgroundColor: `${props.theme["neu300"]}!important`,
      color: `${props.theme["neu900"]}!important`,
      opacity: 0.5,
      cursor: "not-allowed",
    },
  };
};

export const buttonColor = {
  blue: "colorBlue",
  blueDark: "colorBlueDark",
  blueLighten: "colorBlueLighten",
  grey: "colorGrey",
  blueGrey: "colorBlueGrey",
  black: "colorBlack",
  white: "colorWhite",
  primary: "pri500",
  err: "err500",
  neu900: "neu900",
  red: "colorRed",
  neu300: "neu300",
};
export const buttonSize = {
  minimum: 32,
  small: 32,
  medium: 36,
  large: 40,
};
export const minimunSize = {
  minimum: 30,
  small: 60,
  medium: 90,
  large: 100,
};
export const buttonColorHover = {
  blue: "colorBlue",
  blueDark: "colorBlueDark",
  blueLighten: "#7194ab",
  grey: "colorGrey",
  blueGrey: "#5f6268",
  black: "#5f6268",
  primary: "pri500",
  err: "err500",
  red: "colorRed",
};
